// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2yNkv","buttons":"SendReceipts_buttons__1pLzC","email":"SendReceipts_email__2tUeh","bookApptTitle":"SendReceipts_bookApptTitle__PcYQ1"};